"use client";
import { sendGTMEvent } from "./Analytics";
import Button from "./Cards/Button";

interface BackButtonProps {
    link: string;
    title: string;
}
export default function BackButton({ link, title }: BackButtonProps) {
    return (
        <Button
            as="a"
            href={link}
            hasIcon={true}
            iconSrc="/Icons/arrowLeftBlack.svg"
            iconPlacement="left"
            text="zurück"
            backgroundColor=""
            border=""
            textColor="text-black"
            paddings=""
            onClick={() => {
                sendGTMEvent({
                    event: "cta_click",
                    section_title: title,
                    section_index: "1",
                    cta_text: "zurück",
                    cta_link: process.env.NEXT_PUBLIC_URL + link,
                });
            }}
        />
    );
}
